import { Omit } from 'react-router';
import { Action } from 'redux';

export default interface IFunding {
  isSaving: boolean;
  editMode: boolean;
  formDirty: boolean;
  founded: number;
  fundingToDate: string[];
  funding: IInvestmentRounds[];
  dispatch: (v?: Action) => void;
}

export type TFunding = {
  data: {
    funding: TFundingData[];
    fundingToDate: string[];
  };
  dirtyCall: boolean;
};

export interface IInvestmentRounds {
  id: number;
  date: string;
  funding_type: string;
  money_raised: string;
  name: string;
  share_price: string;
  website?: string;
  slug?: string;
  specialization?: ESpecialization;
}

export interface TFundingData extends Omit<IInvestmentRounds, 'id'> {
  id: number | string;
  _destroy?: 1;
}

export interface IFundingRowProps {
  data: TFundingData;
  round: number;
  editMode: boolean;
  deleteRow: (id:string|number) => void;
  changeValue: (id:string|number, e:any) => void;
  dispatch: (v?: Action) => void;
}

export type TFundingRowState = {
  editing: boolean;
  hideError: {
    [key: string]: boolean;
  };
};

export type TType = {[key: string]: string};

export enum ESpecialization {
  EquityPitch = 'EquityPitch',
  ConvertibleNotePitch = 'ConvertibleNotePitch',
  FundPitch = 'FundPitch',
  TokenPitch = 'TokenPitch',
}

